export default __webpack_public_path__ + "static/media/element_70.94032140.jpg";